import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import analyticsTracker from '../utils/analyticsTracker';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password,
      });

      onLogin(response.data.user, response.data.access_token);
      analyticsTracker.trackEvent('login', 'login', 'action', { method: 'email' });
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="login-page">
      <div className="auth-box">
        <div className="auth-logo">
          <img 
            src="/stewie_front.png"
            alt="Stewie Logo"
            className="auth-logo-image"
          />
          Ask Stewie
        </div>
        <p className="auth-subtitle">Sign in to access union resources</p>

        {error && <div className="error-message" data-testid="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email-input"
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
              placeholder="Enter your password"
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-link">
          Don't have an account? <Link to="/register" data-testid="register-link">Register here</Link>
        </div>

        <div className="qr-code-section">
          <p className="qr-label">Share this app</p>
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin)}`}
            alt="QR Code to access Ask Stewie"
            className="qr-code-image"
            data-testid="qr-code"
          />
          <p className="qr-hint">Scan to access on mobile</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
